/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _helpersConnectData = require('helpers/connectData');

var _helpersConnectData2 = _interopRequireDefault(_helpersConnectData);

var _reactRedux = require('react-redux');

var _reduxModulesPage = require('redux/modules/page');

function fetchDataDeferred(getState, dispatch) {
	var promises = [];
	var state = getState();

	if (!_reduxModulesPage.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesPage.load(state.router.params.page)));
	}

	return _Promise.all(promises);
}

var Page = (function (_Component) {
	_inherits(Page, _Component);

	function Page() {
		_classCallCheck(this, _Page);

		_Component.apply(this, arguments);
	}

	Page.prototype.render = function render() {
		var _classNames;

		var styles = require('./Page.css');

		// Show loading spinner while article is fetched
		if (this.props.loading || this.props.loading === undefined) {
			return _react2['default'].createElement(
				'main',
				{ className: styles.Base },
				_react2['default'].createElement(_reactLoader2['default'], {
					className: 'spinner',
					color: 'rgb(255, 78, 61)',
					corners: 0,
					direction: 1,
					hwaccel: true,
					left: '50%',
					length: 6,
					lines: 13,
					opacity: 0.1,
					radius: 7,
					rotate: 13,
					scale: 1.00,
					shadow: false,
					speed: 2,
					top: '50%',
					trail: 60,
					width: 2,
					zIndex: 2e9 })
			);
		}

		var page = this.props.page;

		var contentStyles = _classnames2['default']((_classNames = {}, _classNames[styles.Content] = true, _classNames.CMSContent = true, _classNames));

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: page.title }),
			_react2['default'].createElement(
				'article',
				{ className: styles.Article },
				_react2['default'].createElement(
					'header',
					{ className: styles.Header },
					_react2['default'].createElement(
						'h1',
						null,
						page.title
					)
				),
				_react2['default'].createElement('div', { className: contentStyles, dangerouslySetInnerHTML: { __html: page.post_content } })
			)
		);
	};

	_createClass(Page, null, [{
		key: 'propTypes',
		value: {
			loading: _react.PropTypes.bool,
			location: _react.PropTypes.object,
			page: _react.PropTypes.object,
			error: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _Page = Page;
	Page = _reactRedux.connect(function (state) {
		return {
			page: state.page.data,
			error: state.page.error,
			loading: state.page.loading
		};
	})(Page) || Page;
	Page = _helpersConnectData2['default'](null, fetchDataDeferred)(Page) || Page;
	return Page;
})(_react.Component);

exports['default'] = Page;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Page/Page.js
 ** module id = 707
 ** module chunks = 0
 **/